import { useOrderSummaryStore } from '@/stores/orderSummary.store';
import { getEffectiveBu, normalizeBusinessUnit } from '@/utils/bu.utils';
import type { RouteLocationNormalized } from 'vue-router';
import { BUSINESS_UNITS, type AccountConfigurationStrategy } from '@/modules/bu/registry.base';
import { getBusinessUnitRuntime } from '@/modules/bu/registry.runtime';

export function getAccountStrategy(
  to_route?: RouteLocationNormalized,
): AccountConfigurationStrategy {
  const path_value = to_route?.path ?? window.location.pathname;
  // Route context first, then the order summary, then the first product.
  const bu =
    getEffectiveBu({ path_value, origin_value: window.location.origin, use_stored: true }) ??
    normalizeBusinessUnit(useOrderSummaryStore().orderSummary?.business_unit) ??
    BUSINESS_UNITS[0].key;

  return getBusinessUnitRuntime(bu)!.resolveEntryRoute();
}
